import React, {useEffect, useState} from 'react';
import {AudienceItem} from '../interfaces';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import faker from 'faker';

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend
);

const options:any = {
	responsive: true,
	maintainAspectRatio: false,
	//indexAxis: 'y' as const,
	scales: {
		YAxis: {
			display: false
		}
	},
	plugins: {
		legend: {
			display: false,
			position: 'top' as const
		}
	}
};


interface AudienceCat {
	brands?: AudienceItem[]
	color?: string
}


interface DataSetItem {
	label?: string
	data: number[]
	backgroundColor?: string
	borderRadius?: number
}

interface DataItem {
	labels: string[]
	datasets: DataSetItem[]
}


export default function VerticalChart({brands, color}:AudienceCat):JSX.Element {

	const [data, setData] = useState<DataItem>({
		labels: [],
		datasets: [
			{
				label: 'Dataset 1',
				data: [],
				backgroundColor: 'rgba(255, 99, 132, 0.5)'
			}
		]
	});

	useEffect(():any => {
		if(brands && brands.length > 0){
			const ll:string[] = [];
			const ww:number[] = [];
			brands.map(({name}:AudienceItem, index:number):void =>{
				if(index < 5){
					ll.push(name);
				}
			});

			brands.map(({weight}:AudienceItem, index:number):void=>{
				if(index < 5){
					ww.push(weight);
				}
			});


			const d:DataItem = {
				labels: ll,
				datasets: [
					{
						label: 'Brands',
						data: ww,
						backgroundColor: color || 'rgba(255, 99, 132, 0.5)',
						borderRadius: 40
					}
				]
			};

			setData(d);

		}
	},[brands]);


	if (data.labels.length > 0){
		return <div className="flex grows min-h-300px">
			<Bar className="grows h-100 w-100" options={options} data={data} />
		</div>;
	}
	else {
		return <p>Loading...</p>;
	}

}
